import { Controller } from "@hotwired/stimulus"
import { syncManager } from "../lib/sync_manager"
import { networkStatus } from "../lib/network_status"

export default class extends Controller {
  connect() {
    this.initTheme()
    this.initNetworkStatus()
    this.initInstallPrompt()
    if (document.body.dataset.loggedIn === "true") {
      this.initSync()
    }
  }

  initInstallPrompt() {
    // Capture beforeinstallprompt for browsers that support it (Chrome, Edge, Samsung)
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault()
      window.deferredInstallPrompt = e
      window.dispatchEvent(new Event("pwa-install-available"))
    })

    window.addEventListener("appinstalled", () => {
      window.deferredInstallPrompt = null
      window.dispatchEvent(new Event("pwa-installed"))
    })
  }

  initTheme() {
    const stored = localStorage.getItem("pwa-theme")
    if (stored === "dark" || (!stored && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
      document.documentElement.classList.add("dark")
      document.documentElement.setAttribute("data-theme", "dark")
    }
  }

  toggleTheme() {
    const isDark = document.documentElement.classList.toggle("dark")
    document.documentElement.setAttribute("data-theme", isDark ? "dark" : "light")
    localStorage.setItem("pwa-theme", isDark ? "dark" : "light")
  }

  initNetworkStatus() {
    const banner = document.getElementById("offline-banner")
    if (!banner) return

    const update = (online) => {
      if (online) {
        banner.classList.add("hidden")
      } else {
        banner.classList.remove("hidden")
      }
      this.updatePendingBadge()
    }

    // Subscribe to real connectivity changes (health-check based)
    networkStatus.onChange(update)
    update(networkStatus.online)
  }

  initSync() {
    // Run initial sync
    syncManager.sync()

    // Update pending badge whenever sync state changes
    syncManager.onChange(() => {
      this.updatePendingBadge()
    })
  }

  async updatePendingBadge() {
    const badge = document.getElementById("pending-count")
    if (!badge) return

    try {
      const count = await syncManager.getPendingCount()
      if (count > 0) {
        badge.textContent = count
        badge.classList.remove("hidden")
      } else {
        badge.classList.add("hidden")
      }
    } catch (e) {
      badge.classList.add("hidden")
    }
  }
}
